// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uWbv8ph8RFOgmctb4c8\\+2g\\=\\={margin-right:1rem}", "",{"version":3,"sources":["webpack://./resources/js/components/PostView/DeveloperPostContent/DeveloperPostSections/BuildingProperties/AmenityList/SwimPoolFountainAmenity/styles.module.scss"],"names":[],"mappings":"AAAA,6BACI,iBACJ","sourcesContent":[".fountain_icon {\n    margin-right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fountain_icon": "uWbv8ph8RFOgmctb4c8+2g=="
};
export default ___CSS_LOADER_EXPORT___;
